<template>
  <div>
    暂无...
  </div>
</template>

<script>
export default {
  name: "index"
}
</script>

<style scoped>

</style>
